// src/app/auth/role-guard.service.ts
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
// import decode from 'jwt-decode';
import {AuthService} from '../services';
import {Observable} from 'rxjs/Observable';
@Injectable()
export class RoleGuard implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {
  }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    // this will be passed from the route config
    // on the data property
    //const expectedRole = route.data.expectedRole;
    /*const token = localStorage.getItem('token');
    // decode the token to get its payload
    const tokenPayload = decode(token);
    if (
      !this.authService.isAuthenticated() ||
      tokenPayload.role !== expectedRole
    ) {
      this.router.navigate(['login']);
      return false;
    }*/
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/guards/role.guard.ts